export default "__VITE_ASSET__DmwFuta7__"